import * as React from 'react';
import {
    SelectInput,
} from 'react-admin';
import PropTypes from 'prop-types';
// import { useRecordContext } from 'react-admin';

const choices = [
    { id: 'azure_storage', name: 'Azure Storage' },
    { id: 'mysql', name: 'MySQL' },
    { id: 'postgres', name: 'Postgres' },
    { id: 'azure_sql', name: 'Azure SQL' },
    { id: 'azure_appservice', name: 'Azure AppService' },
];

const ResourceTypesInput = (props) => {
    // const { source } = props;
    // const record = useRecordContext(props);

    return (
        <SelectInput choices={choices} optionValue="id" {...props} />
    );
};

ResourceTypesInput.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default ResourceTypesInput;
